import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {TimetableEntry} from '../shared/TimetableEntry';
import {MiniBookAdminService} from './mini-book-admin.service';

@Injectable()
export class TimetableEntryPublicService {

  constructor(private http: HttpClient, private adminService: MiniBookAdminService) { }

  getTimetableEntries(): Observable<TimetableEntry[]> {
    return this.http.get<any[]>(`${environment.url}${this.adminService.tenant}/timetableEntries`).pipe(
      map<any[], TimetableEntry[]>(data => data.map(value => TimetableEntry.createFromJson(value)))
    );
  }

}
